import { api } from '../index.js'
import _ from 'lodash'

export default {
  namespaced: true,

  state: {
    substitutionTags: []
  },

  mutations: {
    updateSubstitutionTags(state, tags) {
      state.substitutionTags = tags
    }
  },

  actions: {
    async fetchAll({ commit, state }) {
      /*let [substitutionTags] = await api.substitution_tags.all()
      commit('updateSubstitutionTags', substitutionTags)*/
    }
  },

  getters: {
    groupedSubstitutionTags(state) {
      return _.groupBy(state.substitutionTags, 'type')
    }
  }
}
